// Find the HTML element
const orientationWarning = document.getElementById("orientation-warning");

// This is the function that shows/hides the warning
function checkOrientation() {
  if (!orientationWarning) {
    // Failsafe if the element doesn't exist
    return;
  }

  const mobileMaxWidth = 768; // The max-width to be considered "mobile"
  const isMobileSize = window.innerWidth < mobileMaxWidth;
  const isLandscape = window.matchMedia("(orientation: landscape)").matches;

  if (isMobileSize && isLandscape) {
    // If on a small screen AND in landscape, show the warning
    orientationWarning.style.display = "flex";
  } else {
    // Otherwise, hide it
    orientationWarning.style.display = "none";
  }
}

// Listen for events that might change the orientation or size
window.addEventListener("orientationchange", checkOrientation);
window.addEventListener("resize", checkOrientation);

// Run the check once when the page first loads
document.addEventListener("DOMContentLoaded", checkOrientation);
